import { createContext } from "react";

const packagesContext = createContext();

export default packagesContext;